module.exports = __webpack_public_path__ + "statics/img/02.25bc190c.png";